const WORD_CHAR_PATTERN = /[\p{L}\p{N}_]/u;

export function parseQuotedPhraseQuery(query: string): string | null {
  const trimmed = query.trim();
  const match = trimmed.match(/^"([^"]+)"$/);
  if (!match) {
    return null;
  }

  const phrase = match[1].trim();
  return phrase.length > 0 ? phrase : null;
}

export function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function findWholeWordPhraseRanges(
  text: string,
  phrase: string
): [number, number][] {
  const words = phrase.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return [];
  }

  const regex = new RegExp(words.map(escapeRegExp).join('\\s+'), 'giu');
  const ranges: [number, number][] = [];

  for (const match of text.matchAll(regex)) {
    const matched = match[0];
    const start = match.index ?? 0;
    const end = start + matched.length;
    const before = start > 0 ? text.slice(start - 1, start) : '';
    const after = end < text.length ? text.slice(end, end + 1) : '';

    if (
      (!before || !WORD_CHAR_PATTERN.test(before)) &&
      (!after || !WORD_CHAR_PATTERN.test(after))
    ) {
      ranges.push([start, end]);
    }
  }

  return ranges;
}

export function matchesWholeWordPhrase(text: string, phrase: string): boolean {
  return findWholeWordPhraseRanges(text, phrase).length > 0;
}

export function toSearchableTextValues(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.flatMap(item => toSearchableTextValues(item));
  }

  if (typeof value !== 'string') {
    return [];
  }

  const trimmed = value.trim();
  if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      if (Array.isArray(parsed)) {
        return parsed.flatMap(item => toSearchableTextValues(item));
      }
    } catch {}
  }

  return [value];
}
